var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.510695 141.605388h132.553218c12.769898 0 23.103972-10.344313 23.103972-23.103972s-10.333051-23.103972-23.103972-23.103973H234.510695c-76.441231 0-138.62281 62.18158-138.62281 138.622811v554.491241c0 76.441231 62.18158 138.62281 138.62281 138.62281h132.553218c12.769898 0 23.103972-10.345337 23.103972-23.103972 0-12.758635-10.333051-23.103972-23.103972-23.103973H234.510695c-50.967988 0-92.414866-41.458141-92.414866-92.414865V234.020254c-0.001024-50.956725 41.445854-92.414866 92.414866-92.414866zM789.000912 95.397443H656.447694c-12.769898 0-23.103972 10.344313-23.103972 23.103973s10.333051 23.103972 23.103972 23.103972h132.553218c50.967988 0 92.414866 41.458141 92.414865 92.414866v554.491241c0 50.956725-41.446878 92.414866-92.414865 92.414865H656.447694c-12.769898 0-23.103972 10.344313-23.103972 23.103973 0 12.758635 10.333051 23.103972 23.103972 23.103972h132.553218c76.441231 0 138.62281-62.18158 138.62281-138.62281V234.020254c0-76.441231-62.18158-138.62281-138.62281-138.622811z",
    fill: "#22C67F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M731.241493 545.921321H269.166141c-19.139488 0-34.655447-15.515958-34.655446-34.655447s15.515958-34.655447 34.655446-34.655446H731.241493c19.139488 0 34.655447 15.515958 34.655447 34.655446s-15.514934 34.655447-34.655447 34.655447z",
    fill: "#74E8AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo27);
export default __webpack_public_path__ + "static/media/logo (27).2fbbe9db3ce55bf25a006adaf6313669.svg";
export { ForwardRef as ReactComponent };